import { render, staticRenderFns } from "./Fixture.vue?vue&type=template&id=398b82ee&scoped=true&"
import script from "./Fixture.vue?vue&type=script&lang=js&"
export * from "./Fixture.vue?vue&type=script&lang=js&"
import style0 from "./Fixture.vue?vue&type=style&index=0&id=398b82ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398b82ee",
  null
  
)

export default component.exports